(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aware-bespoke-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aware-bespoke-featured-stories')) {
  customElements.define('aware-bespoke-featured-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state === 'loaded' || this.dataset.state === 'loading') return;
      this.loadStories();
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.dataset.state === 'loading') delete this.dataset.state;
    }

    async loadStories() {
      const grid = this.querySelector('.ab-stories__grid');
      if (!grid || !this.dataset.sourceUrl) return;
      this.dataset.state = 'loading';
      this.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 12000);

      try {
        const source = new URL(this.dataset.sourceUrl, window.location.origin);
        if (source.origin !== window.location.origin) throw new Error('Invalid story source');
        source.hash = '';
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) source.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(source, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Story source unavailable');
        const sourceDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = sourceDocument.querySelector('template[data-aware-bespoke-featured-cards]');
        if (!cards || !this.isConnected) throw new Error('Story cards unavailable');
        grid.replaceChildren(document.importNode(cards.content, true));
        grid.hidden = !grid.querySelector('.ab-stories__card');
        this.dataset.state = 'loaded';
      } catch {
        if (this.isConnected) this.dataset.state = 'unavailable';
      } finally {
        clearTimeout(timeout);
        this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aware-region-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    let opener;
    let previousOverflow;
    const close = () => document.querySelector('[data-aware-region-dialog][open]')?.close();
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const trigger = target?.closest('[data-aware-region-open]');
      if (trigger) {
        const dialog = document.querySelector('[data-aware-region-dialog]');
        if (!dialog || dialog.open) return;
        opener = trigger;
        const destination = new URL(window.location.href);
        destination.searchParams.delete('country');
        destination.searchParams.delete('currency');
        dialog.querySelector('input[name="return_to"]').value = destination.pathname + destination.search;
        dialog.showModal();
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.querySelector('input[type="search"]')?.focus();
      }
      if (target?.closest('[data-aware-region-close]')) close();
      if (target?.matches('[data-aware-region-dialog]')) {
        const bounds = target.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      }
    });
    document.addEventListener('close', (event) => {
      if (!(event.target instanceof Element) || !event.target.matches('[data-aware-region-dialog]')) return;
      document.body.style.overflow = previousOverflow ?? '';
      opener?.focus();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
